import type { FC } from 'react';
import React, { useState } from 'react';
import { addressValidateContext } from './utils';
import type { AddressValidationConfig } from './@types';

const AddressValidationProvider: FC<AddressValidationConfig> = (props) => {
    const { children, countries: initialCountries, countryList } = props;
    const [countries, setCountries] = useState(initialCountries);

    return <addressValidateContext.Provider value={{ countries, setCountries, countryList }}>{children}</addressValidateContext.Provider>;
};

export default AddressValidationProvider;
